<template lang="pug">
  div.bank-packets.unsorted-packets
    e-toolbar(
    :items="items"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"
    @deleteItems="deleteItems"
    :hideSearch="true"
    :hideAddButton="true"
    )
    e-table(
    :items="items"
    :showCheckbox="false"
    :defaultColumnWidth="150"
    @deleteItem="deleteItem"
    @editItem="distributePacketConfirm"
    editRowLabel="Распределить"
    :actionColumnWidth="200"
    )
      div(slot="number" slot-scope="props")
        router-link(
        tag="a"
        :to="{name: 'bankPackets.unsortedPackets.errors', params: {packetId: props.row.id}, query: {prevRoute: prevRoute}}"
        ) {{props.row.number ? props.row.number : props.row.id}}
      div(slot="file" slot-scope="props")
        a(
        href="#"
        @click.stop.prevent="startDownloadFile(props.row)"
        ) Ошибки при загрузке пачки

    router-view
</template>

<script>
  import {bankPackets} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"

  export default {
    mixins: [tableMixin],
    created () {
      if (this.items && (!this.items._meta.fields.number || !this.items._meta.fields.file)) {
        this.$store.commit(
          'mutateError',
          new Error('В мете отсутствует number и/или file требуемое для отображения ссылки!')
        )
      }
    },
    methods: {
      distributePacket (row) {
        this.$bar.start()
        this.$store.dispatch('updateModel', {
          url: bankPackets.unsortedPacketDistribute(row.id),
          data: {}
        }).then(_ => {
          this.showOnSuccess()
          this.reFetchData()
        }).catch(e => {
          this.$bar.finish()
          this.$e.errorBox(e)
        })
      },
      distributePacketConfirm (row) {
        this.$e.confirmBox(
          'Распределить данную банковскую пачку?',
          ' ',
          'Распределить'
        ).then(_ => {
          this.distributePacket(row)
        })
      },
      getDownloadEndpoint (row) {
        return bankPackets.unsortedPacketErrorDownloadFile(row.id)
      },
      getEndpoint (route) {
        return bankPackets.unsortedPackets(
          tableMixin.methods.getPrevOrCurrentRouteQuery(route)
        )
      },
      getDeleteUrl (id) {
        return null
      }
    }
  }
</script>
